// Foto territori: Wikimedia Commons (licenze CC, con attribuzione agli autori originali).
// Da sostituire con foto reali del titolare quando disponibili.

export const ZONES = [
  {
    slug: "scopello",
    name: "Scopello",
    img: "https://upload.wikimedia.org/wikipedia/commons/d/d8/Tonnara_e_Faraglioni_di_Scopello.jpg",
    i18n: {
      it: {
        province: "Provincia di Trapani",
        alt: "Vista aerea della Tonnara e dei faraglioni di Scopello",
        tagline: "Tra la Tonnara e i faraglioni",
        copy: "Qui ogni proprietà ha un mare che vende da solo: le foto devono solo dimostrarlo. Lavoro tra il baglio del borgo, la Tonnara e la costa dello Zingaro — la luce giusta arriva presto la mattina e infuoca i faraglioni al tramonto. Case vacanze, B&B e dimore di charme fotografate per prenotare, non per essere soltanto guardate.",
        services: ["Case vacanze sul mare", "B&B e dimore di charme", "Contenuti aerei su costa e faraglioni", "Scatti all'ora d'oro"],
      },
      en: {
        province: "Province of Trapani",
        alt: "Aerial view of the Tonnara and faraglioni of Scopello",
        tagline: "Between the Tonnara and the faraglioni",
        copy: "Here every property has a sea that sells itself: the photos just have to prove it. I work between the village baglio, the Tonnara and the Zingaro coast — the right light comes early in the morning and sets the faraglioni ablaze at sunset. Vacation homes, B&Bs and charming residences photographed to be booked, not just looked at.",
        services: ["Seaside vacation homes", "B&Bs and charming residences", "Aerial content over coast and faraglioni", "Golden-hour shots"],
      },
      de: {
        province: "Provinz Trapani",
        alt: "Luftaufnahme der Tonnara und der Faraglioni von Scopello",
        tagline: "Zwischen der Tonnara und den Faraglioni",
        copy: "Hier hat jede Immobilie ein Meer, das sich von selbst verkauft: Die Fotos müssen es nur beweisen. Ich arbeite zwischen dem Baglio des Dorfes, der Tonnara und der Küste des Zingaro — das richtige Licht kommt früh am Morgen und setzt die Faraglioni bei Sonnenuntergang in Brand. Ferienhäuser, B&Bs und charmante Anwesen, fotografiert zum Buchen, nicht nur zum Ansehen.",
        services: ["Ferienhäuser am Meer", "B&Bs und charmante Anwesen", "Luftaufnahmen über Küste und Faraglioni", "Aufnahmen zur goldenen Stunde"],
      },
    },
  },
  {
    slug: "san-vito-lo-capo",
    name: "San Vito Lo Capo",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Spiaggia_di_San_Vito_Lo_Capo_con_ombrelloni_e_monte_Monaco_sullo_sfondo.jpg/1280px-Spiaggia_di_San_Vito_Lo_Capo_con_ombrelloni_e_monte_Monaco_sullo_sfondo.jpg",
    i18n: {
      it: {
        province: "Provincia di Trapani",
        alt: "La spiaggia di San Vito Lo Capo con Monte Monaco sullo sfondo",
        tagline: "La spiaggia più amata di Sicilia",
        copy: "Ospiti da tutta Europa cercano qui la loro estate: ville, residence e appartamenti a due passi dalla sabbia. In un mercato così competitivo vince l'annuncio con le immagini migliori — la luce del mattino sulle camere, l'aperitivo in veranda al tramonto, il mare che entra dalle finestre.",
        services: ["Ville e residence al mare", "Appartamenti per affitti brevi", "Contenuti aerei su spiaggia e golfo", "Gallerie per Airbnb e Booking"],
      },
      en: {
        province: "Province of Trapani",
        alt: "San Vito Lo Capo beach with Monte Monaco in the background",
        tagline: "Sicily's most loved beach",
        copy: "Guests from all over Europe look for their summer here: villas, residences and apartments steps from the sand. In such a competitive market, the listing with the best images wins — morning light on the rooms, aperitivo on the veranda at sunset, the sea coming in through the windows.",
        services: ["Villas and residences by the sea", "Short-term rental apartments", "Aerial content over beach and gulf", "Galleries for Airbnb and Booking"],
      },
      de: {
        province: "Provinz Trapani",
        alt: "Strand von San Vito Lo Capo mit Monte Monaco im Hintergrund",
        tagline: "Siziliens beliebtester Strand",
        copy: "Gäste aus ganz Europa suchen hier ihren Sommer: Villen, Residenzen und Apartments nur wenige Schritte vom Sand. In einem so umkämpften Markt gewinnt das Inserat mit den besten Bildern — Morgenlicht in den Zimmern, Aperitif auf der Veranda bei Sonnenuntergang, das Meer, das durch die Fenster hereinblickt.",
        services: ["Villen und Residenzen am Meer", "Apartments für Kurzzeitmiete", "Luftaufnahmen über Strand und Golf", "Galerien für Airbnb und Booking"],
      },
    },
  },
  {
    slug: "castellammare-del-golfo",
    name: "Castellammare del Golfo",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Castellammare_del_Golfo_-_Porto_-_panoramio.jpg/1280px-Castellammare_del_Golfo_-_Porto_-_panoramio.jpg",
    i18n: {
      it: {
        province: "Provincia di Trapani",
        alt: "Il porto di Castellammare del Golfo con il borgo sul mare",
        tagline: "Il castello sul porto, le ville sul golfo",
        copy: "Il mio porto di partenza — letteralmente. Fotografo proprietà tra la marina, il centro storico e le ville arroccate sul golfo: nessuna costa conosco meglio di questa. Per host, B&B e agenzie di Castellammare: consegna rapida e condizioni da vicino di casa.",
        services: ["Case vacanze e ville sul golfo", "B&B del centro storico", "Contenuti aerei sul porto e la costa", "Pacchetti per agenzie"],
      },
      en: {
        province: "Province of Trapani",
        alt: "The harbor of Castellammare del Golfo with the old town",
        tagline: "The castle on the harbor, the villas over the gulf",
        copy: "My home port — literally. I photograph properties between the marina, the old town and the villas perched over the gulf: no coast I know better than this one. For hosts, B&Bs and agencies in Castellammare: fast delivery and neighborly rates.",
        services: ["Vacation homes and villas on the gulf", "Old-town B&Bs", "Aerial content over harbor and coast", "Packages for agencies"],
      },
      de: {
        province: "Provinz Trapani",
        alt: "Der Hafen von Castellammare del Golfo mit der Altstadt",
        tagline: "Das Kastell am Hafen, die Villen über dem Golf",
        copy: "Mein Heimathafen — buchstäblich. Ich fotografiere Immobilien zwischen Marina, Altstadt und den Villen über dem Golf: Keine Küste kenne ich besser als diese. Für Gastgeber, B&Bs und Agenturen in Castellammare: schnelle Lieferung und Konditionen wie aus der Nachbarschaft.",
        services: ["Ferienhäuser und Villen am Golf", "B&Bs in der Altstadt", "Luftaufnahmen über Hafen und Küste", "Pakete für Agenturen"],
      },
    },
  },
  {
    slug: "palermo",
    name: "Palermo",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Cattedrale_di_Palermo_Ap_2024.jpg/1280px-Cattedrale_di_Palermo_Ap_2024.jpg",
    i18n: {
      it: {
        province: "Provincia di Palermo",
        alt: "La Cattedrale di Palermo",
        tagline: "Palazzi storici e nuovi affitti brevi",
        copy: "Dai palazzi nobiliari del centro ai loft dei nuovi affitti brevi: a Palermo ogni immobile racconta una storia stratificata, e fotografarla bene fa la differenza tra una visita e una prenotazione. Lavoro per host, property manager, boutique hotel e agenzie in tutta la città e la provincia.",
        services: ["Affitti brevi in centro storico", "Boutique hotel e palazzi", "Property manager multi-immobile", "Tour immersivi 3D"],
      },
      en: {
        province: "Province of Palermo",
        alt: "Palermo Cathedral",
        tagline: "Historic palazzi and new short-term rentals",
        copy: "From the noble palazzi of the center to the lofts of the new short-term rentals: in Palermo every property tells a layered story, and photographing it well makes the difference between a view and a booking. I work for hosts, property managers, boutique hotels and agencies across the city and province.",
        services: ["Short-term rentals in the old town", "Boutique hotels and palazzi", "Multi-property property managers", "Immersive 3D tours"],
      },
      de: {
        province: "Provinz Palermo",
        alt: "Der Dom von Palermo",
        tagline: "Historische Palazzi und neue Kurzzeitmieten",
        copy: "Von den Adelspalästen des Zentrums bis zu den Lofts der neuen Kurzzeitmieten: In Palermo erzählt jede Immobilie eine vielschichtige Geschichte, und sie gut zu fotografieren entscheidet über Besichtigung oder Buchung. Ich arbeite für Gastgeber, Property Manager, Boutique-Hotels und Agenturen in der ganzen Stadt und Provinz.",
        services: ["Kurzzeitmieten in der Altstadt", "Boutique-Hotels und Palazzi", "Property Manager mit mehreren Objekten", "Immersive 3D-Touren"],
      },
    },
  },
  {
    slug: "trapani",
    name: "Trapani",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Saline_di_Marsala_illuminate_al_tramonto.jpg/1280px-Saline_di_Marsala_illuminate_al_tramonto.jpg",
    i18n: {
      it: {
        province: "Provincia di Trapani",
        alt: "Le saline della provincia di Trapani al tramonto con il mulino",
        tagline: "Dalle saline al centro storico",
        copy: "Le saline al tramonto, il borgo sul mare, le coste verso Erice e Marsala: la provincia di Trapani è il mio territorio principale. Servizi fotografici per strutture ricettive, agenzie immobiliari e property manager — con trasferte in tutta la Sicilia quando il progetto lo merita.",
        services: ["Hotel e strutture ricettive", "Case vacanze sulla costa", "Agenzie immobiliari", "Trasferte in tutta la Sicilia"],
      },
      en: {
        province: "Province of Trapani",
        alt: "The salt pans of the province of Trapani at sunset with the windmill",
        tagline: "From the salt pans to the old town",
        copy: "Salt pans at sunset, the seaside old town, the coasts towards Erice and Marsala: the province of Trapani is my main territory. Photography for hospitality businesses, real estate agencies and property managers — with travel across Sicily when the project deserves it.",
        services: ["Hotels and hospitality businesses", "Vacation homes on the coast", "Real estate agencies", "Travel across Sicily"],
      },
      de: {
        province: "Provinz Trapani",
        alt: "Die Salinen der Provinz Trapani bei Sonnenuntergang mit Windmühle",
        tagline: "Von den Salinen bis zur Altstadt",
        copy: "Salinen bei Sonnenuntergang, die Altstadt am Meer, die Küsten Richtung Erice und Marsala: Die Provinz Trapani ist mein Hauptrevier. Fotografie für Beherbergungsbetriebe, Immobilienagenturen und Property Manager — mit Einsätzen in ganz Sizilien, wenn das Projekt es verdient.",
        services: ["Hotels und Beherbergungsbetriebe", "Ferienhäuser an der Küste", "Immobilienagenturen", "Einsätze in ganz Sizilien"],
      },
    },
  },
  {
    slug: "marsala",
    name: "Marsala",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Le_Stagnone%2C_Contrada_Spagnola%2C_Marsala_TP%2C_Sicily%2C_Italy_-_panoramio.jpg/1280px-Le_Stagnone%2C_Contrada_Spagnola%2C_Marsala_TP%2C_Sicily%2C_Italy_-_panoramio.jpg",
    i18n: {
      it: {
        province: "Provincia di Trapani",
        alt: "Le saline dello Stagnone di Marsala con le isole della laguna",
        tagline: "Vino, saline e ville sul mare",
        copy: "Tra le cantine storiche, le saline dello Stagnone e le ville della costa, Marsala è un mercato in crescita per affitti brevi e ospitalità. Fotografo case vacanze, masserie e strutture ricettive con la luce calda del tramonto sulle saline — immagini pensate per far prenotare, su ogni portale.",
        services: ["Case vacanze e masserie", "Contenuti aerei sulle saline dello Stagnone", "Scatti al tramonto", "Gallerie per Airbnb e Booking"],
      },
      en: {
        province: "Province of Trapani",
        alt: "The Stagnone salt pans of Marsala with the lagoon islands",
        tagline: "Wine, salt pans and seaside villas",
        copy: "Between historic wineries, the Stagnone salt pans and the villas along the coast, Marsala is a growing market for short-term rentals and hospitality. I photograph vacation homes, masserias and hospitality properties with the warm light of sunset over the salt pans — images made to drive bookings, on every portal.",
        services: ["Vacation homes and masserias", "Aerial content over the Stagnone salt pans", "Sunset shots", "Galleries for Airbnb and Booking"],
      },
      de: {
        province: "Provinz Trapani",
        alt: "Die Salinen des Stagnone bei Marsala mit den Laguneninseln",
        tagline: "Wein, Salinen und Villen am Meer",
        copy: "Zwischen historischen Weinkellern, den Salinen des Stagnone und den Villen entlang der Küste ist Marsala ein wachsender Markt für Kurzzeitmieten und Gastgewerbe. Ich fotografiere Ferienhäuser, Masserien und Beherbergungsbetriebe im warmen Sonnenuntergangslicht über den Salinen — Bilder, die auf jedem Portal Buchungen bringen.",
        services: ["Ferienhäuser und Masserien", "Luftaufnahmen über den Salinen des Stagnone", "Aufnahmen bei Sonnenuntergang", "Galerien für Airbnb und Booking"],
      },
    },
  },
  {
    slug: "cefalu",
    name: "Cefalù",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Cefalu_beach_and_mountain%2C_Sicily%2C_Italy_%289449659111%29.jpg/1280px-Cefalu_beach_and_mountain%2C_Sicily%2C_Italy_%289449659111%29.jpg",
    i18n: {
      it: {
        province: "Provincia di Palermo",
        alt: "La spiaggia di Cefalù con il borgo e la Rocca sullo sfondo",
        tagline: "Il borgo più fotografato del Tirreno",
        copy: "Cefalù vive di turismo internazionale tutto l'anno: qui l'annuncio giusto vale prenotazioni continue. Lavoro tra il centro storico, il lungomare e le ville sulle colline — foto, contenuti aerei e tour immersivo 3D per host, B&B e agenzie della costa palermitana.",
        services: ["B&B del centro storico", "Ville con vista mare", "Contenuti aerei su borgo e Rocca", "Tour immersivi 3D"],
      },
      en: {
        province: "Province of Palermo",
        alt: "Cefalù beach with the old town and the Rocca in the background",
        tagline: "The most photographed village on the Tyrrhenian",
        copy: "Cefalù lives on international tourism all year round: here the right listing means continuous bookings. I work between the old town, the seafront and the villas on the hills — photos, aerial content and immersive 3D tours for hosts, B&Bs and agencies along the Palermo coast.",
        services: ["Old-town B&Bs", "Sea-view villas", "Aerial content over village and Rocca", "Immersive 3D tours"],
      },
      de: {
        province: "Provinz Palermo",
        alt: "Der Strand von Cefalù mit der Altstadt und der Rocca im Hintergrund",
        tagline: "Das meistfotografierte Dorf am Tyrrhenischen Meer",
        copy: "Cefalù lebt das ganze Jahr vom internationalen Tourismus: Hier bedeutet das richtige Inserat kontinuierliche Buchungen. Ich arbeite zwischen Altstadt, Strandpromenade und den Villen in den Hügeln — Fotos, Luftaufnahmen und immersive 3D-Touren für Gastgeber, B&Bs und Agenturen an der Küste von Palermo.",
        services: ["B&Bs in der Altstadt", "Villen mit Meerblick", "Luftaufnahmen über Dorf und Rocca", "Immersive 3D-Touren"],
      },
    },
  },
  {
    slug: "agrigento",
    name: "Agrigento",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Valle_dei_Templi_%E2%80%93_Temple_of_Concordia_2024a.jpg/1280px-Valle_dei_Templi_%E2%80%93_Temple_of_Concordia_2024a.jpg",
    i18n: {
      it: {
        province: "Provincia di Agrigento",
        alt: "Il Tempio della Concordia nella Valle dei Templi di Agrigento",
        tagline: "Dalla Valle dei Templi alla costa",
        copy: "Tra la Valle dei Templi, San Leone e la Scala dei Turchi, l'area di Agrigento attira viaggiatori da tutto il mondo. Servizi fotografici per hotel, B&B e case vacanze che vogliono distinguersi: consegna rapida e immagini pronte per ogni portale.",
        services: ["Hotel e B&B", "Case vacanze a San Leone", "Contenuti aerei sulla costa", "Foto per agenzie immobiliari"],
      },
      en: {
        province: "Province of Agrigento",
        alt: "The Temple of Concordia in the Valley of the Temples, Agrigento",
        tagline: "From the Valley of the Temples to the coast",
        copy: "Between the Valley of the Temples, San Leone and the Scala dei Turchi, the Agrigento area attracts travellers from all over the world. Photography services for hotels, B&Bs and vacation homes that want to stand out: fast delivery and images ready for every portal.",
        services: ["Hotels and B&Bs", "Vacation homes in San Leone", "Aerial content over the coast", "Photos for real estate agencies"],
      },
      de: {
        province: "Provinz Agrigento",
        alt: "Der Concordia-Tempel im Tal der Tempel von Agrigento",
        tagline: "Vom Tal der Tempel bis zur Küste",
        copy: "Zwischen dem Tal der Tempel, San Leone und der Scala dei Turchi zieht die Gegend von Agrigento Reisende aus aller Welt an. Fotografie für Hotels, B&Bs und Ferienhäuser, die sich abheben wollen: schnelle Lieferung und Bilder bereit für jedes Portal.",
        services: ["Hotels und B&Bs", "Ferienhäuser in San Leone", "Luftaufnahmen über der Küste", "Fotos für Immobilienagenturen"],
      },
    },
  },

];
